import { apiClient } from "../client";

export const authService = {
  login: async (email: string, password: string) => {
    const response = await apiClient.post('/api/token/', {
      email,
      password,
    });
    return response.data;
  },

  logout: async () => {
    try {
      const refreshToken = document.cookie
        .split('; ')
        .find((row) => row.startsWith('authToken_refresh='))
        ?.split('=')[1];
      const response = await apiClient.post('/api/logout/', {
        refresh_token: refreshToken ?? '',
      });
      return response.data;
    } catch (error) {
      console.error('Logout error:', error);
      return null;
    }
  },

  refreshToken: async (refresh: string) => {
    const response = await apiClient.post('/api/token/refresh/', {
      refresh,
    });
    return response.data;
  },

  passwordReset: async (email: string) => {
    const response = await apiClient.post('/api/password-reset/', {
      email,
    });
    return response.data;
  },

  passwordResetConfirm: async (uid: string, token: string, newPassword: string, newPassword2: string) => {
    const response = await apiClient.post('/api/password-reset-confirm/', {
      uid,
      token,
      new_password: newPassword,
      new_password2: newPassword2,
    });
    return response.data;
  },
};
